import { NavLink } from 'react-router-dom';
import type { MeResponse } from '@ucp/web/lib';
import { cn } from '../ui/cn';
import { NavMenuIconLabel } from './NavMenuIconLabel';
import { iconForNavItem } from './navIcons';
import { commsTaskNavItems } from './commsTaskNav';
import { ScrollNavBar, taskNavListClassName } from './ScrollNavBar';

/**
 * Role-filtered primary navigation (PRO-0250, D4; reskinned PRO-0260 Phase 1).
 * This is the **Comms** module's tier-2 task nav (PRO-0340).
 * `ScrollNavBar` is the sole tier-2 `<nav>` landmark (NF-10). Items wrap (ADR-014 A18).
 */
export function PrimaryNav({
  user,
  moduleLabel = 'Communications',
}: {
  user: Pick<MeResponse, 'roles' | 'featureFlags'>;
  moduleLabel?: string;
}) {
  const items = commsTaskNavItems(user);

  return (
    <ScrollNavBar aria-label={moduleLabel}>
      <ul className={cn(taskNavListClassName, 'py-2')}>
        {items.map((item) => (
          <li key={item.id}>
            <NavLink
              to={item.path}
              end={item.end ?? false}
              className={({ isActive }) =>
                cn(
                  'inline-flex min-h-11 items-center whitespace-nowrap px-3 py-2 text-base no-underline transition-colors ease-ds',
                  'border-b-2 border-transparent hover:bg-muted',
                  isActive
                    ? 'border-primary font-semibold text-text-primary'
                    : 'font-normal text-text-secondary',
                )
              }
            >
              {({ isActive }) => (
                <NavMenuIconLabel
                  icon={iconForNavItem(item.id)}
                  active={isActive}
                  className="gap-2"
                  iconClassName="h-4 w-4"
                >
                  {item.label}
                </NavMenuIconLabel>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </ScrollNavBar>
  );
}
